import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetSalesListRequestDto } from "../../dtos/get-sales-list-request-dto";
import type { GetSalesListResponseDto } from "../../dtos/get-sales-list-response-dto";
import { UserQueryKeys } from "../../generators/user-query-keys";
import { UserService } from "../../services/user-service";

type UseGetSalesListQueryProps = {
  queryParams: GetSalesListRequestDto;
  options?: UseQueryOptions<GetSalesListResponseDto>;
};

export const useGetSalesListQuery = ({
  queryParams,
  options
}: UseGetSalesListQueryProps) => {
  return useQuery({
    queryKey: UserQueryKeys.getSalesList({ ...queryParams }).queryKey,
    queryFn: async () => {
      return await UserService.getSalesList({ payload: queryParams });
    },
    ...options
  });
};
